export const demoProducts = [
  {
    id: 1,
    name: 'Eternal Legacy Necklace',
    category: 'gold',
    metalType: 'gold',
    metalPurity: '22k',
    type: 'wastage',
    metalWeight: 12.5,
    labourCharge: 4500,
    wastagePercentage: 12,
    basePrice: 0,
    finalPrice: 78500,
    images: ['/images/necklace-1.jpg'],
    description: 'A timeless masterpiece crafted in hallmarked 22k gold. Features intricate handcrafted details.',
    rating: 4.8,
    reviews: 124,
    isNew: true,
    isFeatured: true,
    stock: 5,
    createdAt: '2024-01-15'
  },
  {
    id: 2,
    name: 'Promise Diamond Ring',
    category: 'diamond',
    metalType: 'gold',
    metalPurity: '18k',
    type: 'fixed',
    metalWeight: 3.2,
    basePrice: 85000,
    finalPrice: 85000,
    images: ['/images/ring-1.jpg'],
    description: 'A symbol of eternal love, featuring a certified natural diamond set in 18k gold.',
    rating: 4.9,
    reviews: 89,
    isNew: true,
    isFeatured: true,
    stock: 3,
    createdAt: '2024-01-20'
  },
  {
    id: 3,
    name: 'Heritage Gold Bangles',
    category: 'gold',
    metalType: 'gold',
    metalPurity: '22k',
    type: 'labour',
    metalWeight: 25.0,
    labourCharge: 8000,
    basePrice: 0,
    finalPrice: 145000,
    images: ['/images/bangles-1.jpg'],
    description: 'Traditional craftsmanship meets contemporary design in these heritage bangles.',
    rating: 4.7,
    reviews: 56,
    isNew: false,
    isFeatured: true,
    stock: 4,
    createdAt: '2024-01-10'
  },
  {
    id: 4,
    name: 'Celestial Drop Earrings',
    category: 'silver',
    metalType: 'silver',
    metalPurity: '925',
    type: 'fixed',
    metalWeight: 8.5,
    basePrice: 12500,
    finalPrice: 12500,
    images: ['/images/earrings-1.jpg'],
    description: 'Inspired by the cosmos, these sterling silver drop earrings dance with every movement.',
    rating: 4.6,
    reviews: 34,
    isNew: true,
    isFeatured: false,
    stock: 8,
    createdAt: '2024-01-25'
  },
  {
    id: 5,
    name: 'Lab-Grown Diamond Pendant',
    category: 'diamond',
    metalType: 'gold',
    metalPurity: '14k',
    type: 'fixed',
    metalWeight: 1.8,
    basePrice: 45000,
    finalPrice: 45000,
    images: ['/images/pendant-1.jpg'],
    description: 'Ethically sourced lab-grown diamond pendant with brilliant sparkle.',
    rating: 4.8,
    reviews: 42,
    isNew: true,
    isFeatured: true,
    stock: 6,
    createdAt: '2024-01-28'
  },
  {
    id: 6,
    name: 'Vintage Gold Nose Pin',
    category: 'gold',
    metalType: 'gold',
    metalPurity: '22k',
    type: 'fixed',
    metalWeight: 0.8,
    basePrice: 6500,
    finalPrice: 6500,
    images: ['/images/nosepin-1.jpg'],
    description: 'Delicate vintage-inspired nose pin adorned with a single pearl.',
    rating: 4.5,
    reviews: 28,
    isNew: false,
    isFeatured: false,
    stock: 12,
    createdAt: '2023-12-15'
  },
  {
    id: 7,
    name: 'Royal Emerald Ring',
    category: 'diamond',
    metalType: 'gold',
    metalPurity: '18k',
    type: 'fixed',
    metalWeight: 4.5,
    basePrice: 125000,
    finalPrice: 125000,
    images: ['/images/ring-2.jpg'],
    description: 'Exquisite emerald and diamond ring for special occasions.',
    rating: 4.9,
    reviews: 67,
    isNew: true,
    isFeatured: true,
    stock: 2,
    createdAt: '2024-02-01'
  },
  {
    id: 8,
    name: 'Modern Silver Cufflinks',
    category: 'silver',
    metalType: 'silver',
    metalPurity: '925',
    type: 'fixed',
    metalWeight: 12.0,
    basePrice: 18500,
    finalPrice: 18500,
    images: ['/images/cufflinks-1.jpg'],
    description: 'Contemporary design cufflinks for the modern gentleman.',
    rating: 4.4,
    reviews: 19,
    isNew: false,
    isFeatured: false,
    stock: 15,
    createdAt: '2024-01-05'
  }
];

export const demoOrders = [
  {
    id: 'ORD001',
    customerName: 'Priya Sharma',
    customerPhone: '9876543210',
    products: [
      { id: 1, name: 'Eternal Legacy Necklace', quantity: 1, price: 78500 }
    ],
    totalAmount: 78500,
    status: 'delivered',
    paymentStatus: 'completed',
    orderDate: '2024-02-01',
    deliveryDate: '2024-02-05'
  },
  {
    id: 'ORD002',
    customerName: 'Rahul Mehta',
    customerPhone: '9876543211',
    products: [
      { id: 2, name: 'Promise Diamond Ring', quantity: 1, price: 85000 }
    ],
    totalAmount: 85000,
    status: 'processing',
    paymentStatus: 'completed',
    orderDate: '2024-02-10'
  }
];

export const demoCustomers = [
  {
    id: 'CUST001',
    name: 'Priya Sharma',
    email: 'priya.sharma@email.com',
    phone: '9876543210',
    birthDate: '1990-05-15',
    address: {
      line1: '123, Green Park',
      city: 'New Delhi',
      state: 'Delhi',
      pincode: '110016'
    },
    totalOrders: 3,
    totalSpent: 215000,
    joinDate: '2023-12-01'
  }
];

export const demoMetalPrices = {
  gold: 5200,
  silver: 75,
  platinum: 3200,
  lastUpdated: '2024-02-13T10:30:00Z'
};